import { useEffect, useRef, useState } from 'react';

import { querySelector } from '@/utils';

interface IProps {
  /** ref.current 【和dom之间只传一个】 */
  domRef?: Element;
  /** 监听元素的id名或者类名 */
  dom?: string;
  /** 是否只监听一次 */
  once?: boolean;
  /** 监听方法的options */
  options?: IntersectionObserverInit;
}

/**
 * 返回监听模块是否出现在可视区域
 */
export default function useWatch({ dom, once, domRef, options }: IProps) {
  const [visible, setVisible] = useState(false);
  const observer = useRef<IntersectionObserver | null>(null);

  const customCb: IntersectionObserverCallback = (entries) => {
    if (entries?.length && entries[0].isIntersecting) {
      setVisible(true);
      if (once && observer.current) {
        observer.current.unobserve(entries[0].target);
      }
    } else {
      setVisible(false);
    }
  };

  // dom查询处理
  useEffect(() => {
    let tempDom: Element | null = null;

    if (dom && !tempDom) {
      if ('IntersectionObserver' in window) {
        observer.current = new IntersectionObserver(customCb, options);
        querySelector(dom).then((_dom) => {
          if (_dom && observer.current) {
            observer.current.observe(_dom);
            tempDom = _dom;
          }
        });
      } else {
        setVisible(true);
      }
    }

    return () => {
      tempDom && observer.current?.unobserve?.(tempDom);
    };
  }, [dom]);

  // ref处理
  useEffect(() => {
    if (domRef && !dom) {
      if ('IntersectionObserver' in window) {
        observer.current = new IntersectionObserver(customCb, options);
        observer.current.observe(domRef);
      } else setVisible(true);
    }

    return () => {
      domRef && observer.current?.unobserve?.(domRef);
    };
  }, [domRef]);

  return { visible };
}
